module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_9016.a46d4204.png";